<template>
    <div class="uk-card uk-card-small uk-card-default">
      <div class="uk-card-header">
        <div class="uk-card-title">
          {{ local_page_keys.button_change_password }}
        </div>
      </div>
      <div class="uk-card-body">
        <div>
          <div class="uk-grid uk-grid-small uk-child-width-1-1" data-uk-grid>
            <div>
              <label>
                <div class="uk-margin-small">
                  {{ local_page_keys.label_new_password }}
                </div>
                <div class="uk-margin-small">
                  <div class="uk-inline uk-width-1-1" :class="{'tm-val-error': errorPassword}">
                    <a class="uk-form-icon uk-form-icon-flip" href="#" @click.prevent="togglePasswordVisibility">
                      <md-icon v-if="showPassword">visibility</md-icon>
                      <md-icon v-else>visibility_off</md-icon>
                    </a>
                    <input class="uk-input" :type="inputTypePassword" v-model="password">
                  </div>
                </div>
              </label>
            </div>
            <div>
              <label>
                <div class="uk-margin-small">
                  {{ local_page_keys.label_confirm_new_password }}
                </div>
                <div class="uk-margin-small">
                  <div class="uk-inline uk-width-1-1" :class="{'tm-val-error': errorConfirmPassword}">
                    <a class="uk-form-icon uk-form-icon-flip" href="#" @click.prevent="toggleConfirmPasswordVisibility">
                      <md-icon v-if="showConfirmPassword">visibility</md-icon>
                      <md-icon v-else>visibility_off</md-icon>
                    </a>
                    <input class="uk-input" :type="inputTypeConfirmPassword" v-model="password_confirmation">
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-footer uk-text-right">
        <button @click.prevent="changePassword" class="uk-button tm-button-success">
          {{ local_page_keys.button_update_profile }}
          <span v-if="loader" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
        </button>
      </div>
    </div>
</template>

<script>
import formMixin from "@/mixins/form-mixin";

export default {
  name: "edit-password-card",
  props: {
    user: Object
  },
  components: {},
  mixins: [formMixin],
  data: () => ({
    loader:false,
    password: null,
    password_confirmation: null,
    local_page_keys: {},
    showPassword: false,
    showConfirmPassword: false,
    errorPassword: false,
    errorConfirmPassword: false
  }),
  methods: {
    async changePassword() {
      this.loader = true;
      if (["1", "2", "3"].includes(this.user.id)) {
        await this.$store.dispatch("alerts/error", this.local_page_keys.alert_not_allowed_change_data_of_default_users)
        return
      }
      if (!this.validatePassword()) {
        return;
      }
      const token = window.localStorage.getItem('vue-authenticate.vueauth_access_token');
      this.authorization = 'Bearer ' + token;
      const data = {
        password: this.password,
        password_confirmation: this.password_confirmation
      }
      const url = process.env.VUE_APP_API_BASE_URL + '/user-change-password';
      const authorization = this.authorization;
      let message = this.local_page_keys.confirm_change_password;

      if (confirm(message)) {
        const res = await fetch(url, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': authorization
          },
          body: JSON.stringify(data),
        })
        if (res.status === 200 || res.status === 201) {
          await this.$store.dispatch("alerts/success", this.local_page_keys.alert_success_change_password);
          this.password = null;
          this.password_confirmation = null;
          this.loader = false;
          this.$store.dispatch("logout");
        }
      }
    },
    async validatePassword() {
      this.errorPassword = false;
      this.errorConfirmPassword = false;

      let validate = false;
      let errorMessage = null;
      if (this.password && this.password_confirmation && this.password !== this.password_confirmation) {
        errorMessage = this.local_page_keys.alert_entered_passwords_do_not_match;
        this.errorConfirmPassword = true;
      } else if (!this.password) {
        errorMessage = this.local_page_keys.error_password_required;
        this.errorPassword = true;
      } else if (!this.password_confirmation) {
        errorMessage = this.local_page_keys.error_password_confirm_required;
        this.errorConfirmPassword = true;
      } else validate = true;

      if (!validate && errorMessage) {
        await this.$store.dispatch("alerts/error", errorMessage);
        this.loader = false;
      }

      return validate;
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  },
  computed: {
    inputTypePassword() {
      return this.showPassword ? 'text' : 'password';
    },
    inputTypeConfirmPassword() {
      return this.showConfirmPassword ? 'text' : 'password';
    }
  },
  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPages(['user-change-password', 'user-localization','user-edit-profile']);
  }
};
</script>